<template>
  <div id="app">

    <ul id="dropdownMore" class="dropdown-content">
      <li>
        <router-link :to="{ name: 'Credits' }">Credits</router-link>
      </li>
      <li>
        <a v-on:click="logout()">Logout</a>
      </li>
    </ul>
  
    <nav>
      <div class="nav-wrapper">
        <a href="/" class="brand-logo center logo-text">Les Opens</a>
        <ul class="right" v-if="isAuthenticated()">
            <li><a class="dropdown-trigger"  ref="moreMenu" href="#!" data-target="dropdownMore"><i class="material-icons">more_vert</i></a></li>
        </ul>
      </div>
    </nav>

   

    <div class="container">
      <router-view><Login/></router-view>
    </div>

    <div id="fab-menu" class="fixed-action-btn toolbar" v-if="isAuthenticated()" ref="fab">
      <a class="btn-floating btn-large red">
        <i class="large material-icons">menu</i>
      </a>
      <ul>
        <li>
          <router-link class="btn-floating" :to="{ name: 'Athlete' }">
            <i class="material-icons">accessibility</i>
          </router-link>
        </li>
        <li>
          <router-link class="btn-floating" :to="{ name: 'Sessions' }">
            <i class="material-icons">fitness_center</i>
          </router-link>
        </li>
        <li>
          <router-link class="btn-floating" :to="{ name: 'Records' }">
            <i class="material-icons">flag</i>
          </router-link>
        </li>
        <li>
          <router-link class="btn-floating" :to="{ name: 'Device' }">
            <i class="material-icons">sports_esports</i>
          </router-link>
        </li>
        <li v-if="isCoach()">
          <router-link class="btn-floating" :to="{ name: 'Coach' }">
            <i class="material-icons">developer_mode</i>
          </router-link>
        </li>
      </ul>
    </div>

    <!-- Tap Target Structure -->
    <div class="tap-target" data-target="fab-menu" v-if="isAuthenticated()" ref="tap">
      <div class="tap-target-content">
        <div class="container white-text" style="margin-top: 70px;">
          <h5>Aloha {{ name }}</h5>
          <p>
            Welcome to Les Opens ! The app to reach the next level within open sessions along your regular crossfit
            workout.
          </p>
          <p>Have fun and work hard!</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import M from 'materialize-css'
import 'materialize-css/dist/css/materialize.css'
import api from '@/api'
export default {
  name: 'app',
  data: function () {
    return {
      name: undefined
    }
  },
  mounted: function () {
    if (api.hasCurrentUser()) {
      this.name = api.getCurrentUser().athlete.name
      api.cacheLoad() // load dynamic resources in cache (Localstorage)
    }
    M.FloatingActionButton.init(this.$refs.fab, {
      toolbarEnabled: true
    })
    M.Dropdown.init(this.$refs.moreMenu)

    this.$router.replace({name: 'Home'}) // go to home by default
  },
  methods: {
    isAuthenticated: function () {
      return api.hasCurrentUser()
    },
    logout: function () {
      api.removeCurrentUser()
      this.$router.push({name: 'Login'})
    },
    isCoach () {
      return api.hasRole('coach')
    }
  }

}
</script>

<style>
@import url("https://fonts.googleapis.com/icon?family=Material+Icons");
@import url("https://fonts.googleapis.com/css?family=Lobster&display=swap");

.logo-text {
  font-family: "Lobster", cursive;
}

.fullscreen {
  width: 100%;
  max-height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue